import { Typography, useTheme } from "@mui/material";
import type { FC } from "react";

type Props = {
	text: string;
};

export const SectionEmptyText: FC<Props> = ({ text }) => {
	const { palette, spacingTokens } = useTheme();

	return (
		<Typography
			variant="body2"
			color={palette.grey[400]}
			px={spacingTokens.lg}
			py={spacingTokens.md}
		>
			{text}
		</Typography>
	);
};
